import type { ExternalReviewSettings } from 'api/ExternalReviewSettings'

export type PreviewVariant = 'legacy' | 'uplift'

type PreviewVariantSettings = Partial<ExternalReviewSettings> & {
  previewVariant?: PreviewVariant
}

export const resolvePostPreviewVariant = (
  settings?: PreviewVariantSettings
): PreviewVariant => {
  if (settings?.previewVariant === 'uplift') {
    return 'uplift'
  }

  if (settings?.previewVariant === 'legacy') {
    return 'legacy'
  }

  return 'uplift'
}
